module.exports = __webpack_public_path__ + "img/triangle.2b38816b.svg";